import React, { useState } from "react";

import UploadOnboardingFile from "components/UploadOnboardingFile/UploadOnboardingFile";
import { ONBOARDING_TABS, ZERO } from "constants/constants";

import styles from "./OnBoarding.module.scss";

const OnBoarding = () => {
    const [activeTabId, setActiveTabId] = useState(ONBOARDING_TABS[ZERO].id);
    const activeTab =
        ONBOARDING_TABS.find((tab) => tab.id === activeTabId) ||
        ONBOARDING_TABS[ZERO];

    return (
        <div className={styles.mainContainer}>
            <div className={styles.page}>
                <header className={styles.pageHeader}>
                    <h1 className={styles.pageTitle}>Onboarding</h1>
                </header>
                <div className={styles.tabs} role="tablist" aria-label="Onboarding type">
                    {ONBOARDING_TABS.map((tab) => {
                        const isActive = tab.id === activeTabId;

                        return (
                            <button
                                key={tab.id}
                                type="button"
                                role="tab"
                                id={`${tab.id}-tab`}
                                aria-selected={isActive}
                                aria-controls="onboarding-tab-panel"
                                className={`${styles.tab} ${isActive ? styles.activeTab : ""}`}
                                onClick={() => setActiveTabId(tab.id)}
                            >
                                {tab.label}
                            </button>
                        );
                    })}
                </div>
                <div
                    id="onboarding-tab-panel"
                    role="tabpanel"
                    aria-labelledby={`${activeTab.id}-tab`}
                >
                    <UploadOnboardingFile
                        key={activeTab.id}
                        scriptId={activeTab.scriptId}
                        uploadTitle={activeTab.uploadTitle}
                        historyTitle={activeTab.historyTitle}
                        emptyStateLabel={activeTab.emptyStateLabel}
                    />
                </div>
            </div>
        </div>
    );
};
export default OnBoarding;
